var _defs, _path, _path2, _rect;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRaLogoLettersWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1440 1373.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ffffff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Rise Art 1440px") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M484.51,610.88q0,107.42-93.75,135.35L504.38,903.95H411.25L307.55,758H211.33V903.95H138.05v-434H299.48q99.35,0,142.19,33.53t42.84,107.42M387,672.35q22.35-19.24,22.36-61.78t-23-58.37q-23-15.84-82-15.83H211.33V691.59h91.26q62.09,0,84.44-19.24"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M962.93,805.21l-43.47,98.73H841.24l191.23-434h78.24l191.23,434h-78.24l-43.45-98.73H962.93Zm187.52-67.68-78.87-178.82L992.74,737.53h157.72Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 664.2,
    y: 260.93,
    width: 64.4,
    height: 852.01
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRaLogoLettersWhite);
export default __webpack_public_path__ + "static/media/ra-logo-letters-white.bf3bfb8292cdd7d37735d03ae1c054a235eac49617b96b2825c854060ccf0b77.svg";
export { ForwardRef as ReactComponent };